import { useQuery } from "@tanstack/react-query";
import { fetchAllPaginated } from "@/lib/supabase-paginate";

/**
 * VIB-1189: fakturert beløp (eks. mva) per prosjekt, for faktureringsstatus i
 * prosjektlista. Σ invoices.amount_excl_vat ?? amount — samme basis som
 * prosjektkortet (ProjectDetailLayout/ProjectHeader), så status er konsistent.
 */

export interface InvoiceAmountRow {
  project_id: string | null;
  amount: number | null;
  amount_excl_vat: number | null;
}

/** Ren aggregering: Σ (amount_excl_vat ?? amount) per project_id. */
export function buildInvoicedMap(rows: InvoiceAmountRow[]): Map<string, number> {
  const map = new Map<string, number>();
  for (const r of rows) {
    if (!r.project_id) continue;
    const amt = Number(r.amount_excl_vat ?? r.amount ?? 0);
    map.set(r.project_id, (map.get(r.project_id) ?? 0) + amt);
  }
  return map;
}

export function useProjectInvoiced() {
  return useQuery({
    queryKey: ["project-invoiced"],
    queryFn: async () => {
      const rows = await fetchAllPaginated<InvoiceAmountRow>(
        "invoices",
        "project_id, amount, amount_excl_vat",
      );
      return buildInvoicedMap(rows);
    },
    staleTime: 5 * 60 * 1000,
  });
}
